const TOP = '45%';
const TITLE_SIZE = 48;
export const PIE_RADIUS = '70%';

export const PIE_CHART_OPTIONS = {
    title: {
        left: 'center',
        top: TOP,
        padding: [- TITLE_SIZE / 2, 0, 0, 0],
        textStyle: {
            fontSize: TITLE_SIZE,
            fontWeight: 400,
        },
    },
    series: [{
        type: 'pie',
        radius: ['0%', PIE_RADIUS],
        center: ['50%', TOP],
        avoidLabelOverlap: true,
        stillShowZeroSum: false,
        label: {
            normal: {
                show: false,
                position: 'inside',
                formatter: '{c}',
                fontSize: 16,
            },
        },
        labelLine: {
            length: 5,
            length2: 10,
        },
    }],
};
